"use client";

import { type FormatCategoryWithOther as FormatCategory } from "@garimpa/lib/formatGroups";

import { CassetteTape } from "./cassette-tape";
import { CdDisc } from "./cd-disc";
import { DvdDisc } from "./dvd-disc";
import { VinylDisc } from "./vinyl-disc";

export function DiscVisual({
  category,
  title,
  artistName,
}: {
  category: FormatCategory;
  title: string;
  artistName: string | null;
}) {
  switch (category) {
    case "vinyl":
      return <VinylDisc title={title} artistName={artistName} />;
    case "cd":
      return <CdDisc />;
    case "cassette":
      return <CassetteTape title={title} artistName={artistName} />;
    case "video":
      return <DvdDisc />;
    default:
      return <VinylDisc title={title} artistName={artistName} />;
  }
}
